import React, { useRef } from 'react'

import ExerciseAndDiet from './ExerciseAndDiet'
import { HeroLayout } from './RedUI'
import { useUneeqState } from 'uneeq-react-core'
import { Box } from 'rebass'
import { useScrollToTopOnValueChange } from '../../hooks/useScrollToTopOnValueChange'

interface ExerciseAndDietSectionProps {
  items: any[]
  title: string
}

const ExerciseAndDietSection = ({
  items,
  title
}: ExerciseAndDietSectionProps) => {
  const { currentSectionDate } = useUneeqState()

  const containerRef = useRef<HTMLDivElement>(null)

  const dateCompare = (a: Date, b: Date) =>
    new Date(a).getTime() === new Date(b).getTime()

  useScrollToTopOnValueChange(currentSectionDate, containerRef, dateCompare)

  return (
    <HeroLayout title={title}>
      <Box
        ref={containerRef}
        sx={{ overflowY: 'scroll' }}
        variant="redContentUnwrapped"
      >
        {items.map((item: any, index) => (
          <ExerciseAndDiet item={item} index={index} />
        ))}
      </Box>
    </HeroLayout>
  )
}

export default ExerciseAndDietSection
